module.exports = __webpack_public_path__ + "static/img/7.3883190.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/7.png
// module id = xm7q
// module chunks = 0